// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"08ed2d1eec279ac0c51c","3770":"45dce054be87264c89a9","4997":"2d800033877b6c3e98f0"}[chunkId] + ".chunk.js";
};